import React, { useState, useCallback, Fragment } from 'react';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import cx from 'classnames';

import { FeatureFlagsAvailableFlagSettings } from '@zola-helpers/client/dist/es/constants/navConstants';

import useKeyboardShortcut from '../../hooks/useKeyboardShortcut';

import { FeatureFlags, useFeatureFlags } from './FeatureFlags';
import { ExperimentFlags } from './ExperimentFlags';

import styles from './FeatureToggle.module.less';
import { UserSettingsOverride } from './UserSettingsOverride';

interface FeatureToggleProps {
  userContext: UserContext;
  productFlags: FeatureFlagsAvailableFlagSettings;
  product: string;
}

export const FeatureToggle = ({
  userContext,
  productFlags,
  product,
}: FeatureToggleProps): JSX.Element => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleKeyboardShortcut = useCallback(() => {
    setShowDropdown((currentShowDropdown) => !currentShowDropdown);
  }, [setShowDropdown]);
  const keys = ['Control', 'Shift', 'J'];
  useKeyboardShortcut(keys, handleKeyboardShortcut);

  const featureFlagsByDomain = useFeatureFlags({ product, productFlags });

  return showDropdown ? (
    <div className={cx(styles.featureToggle, { [styles.isUser]: !userContext?.is_guest })}>
      <div className={styles.toggleContainer}>
        <ExperimentFlags userContext={userContext} />
        <FeatureFlags featureFlagsByDomain={featureFlagsByDomain} />
      </div>

      <UserSettingsOverride />
    </div>
  ) : (
    <Fragment />
  );
};

export default FeatureToggle;
